import { Heart, ExternalLink } from 'lucide-react';
import { CTA_LINKS } from '../constants/ctaLinks';
import { trackAppinesCtaClicked } from '../utils/analyticsEvents';

interface AppinesHiringBonusProps {
  professionId?: string;
  variant?: 'sidebar' | 'mobile-sticky';
}

export default function AppinesHiringBonus({
  professionId = 'infirmier',
  variant = 'sidebar',
}: AppinesHiringBonusProps) {
  const cvSubmissionLink = professionId === 'infirmier'
    ? CTA_LINKS.INFIRMIER.CV_SUBMISSION
    : CTA_LINKS.GENERAL.MAIN_WEBSITE;

  if (variant === 'mobile-sticky') {
    return (
      <div className="bg-gradient-to-r from-emerald-50 to-green-100 border-t border-emerald-200 px-4 py-2.5 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 flex-1 min-w-0">
          <div className="p-1.5 bg-emerald-100 rounded-md flex-shrink-0">
            <Heart className="w-4 h-4 text-emerald-600" />
          </div>
          <p className="text-xs font-medium text-emerald-900 leading-tight">
            300€ de prime à l'embauche avec App'Ines
          </p>
        </div>
        <a
          href={cvSubmissionLink}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackAppinesCtaClicked('hiring_bonus_mobile', cvSubmissionLink)}
          className="flex-shrink-0 inline-flex items-center gap-1 px-3 py-1.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-md text-xs font-semibold transition-colors whitespace-nowrap"
        >
          En savoir plus
          <ExternalLink className="w-3 h-3" />
        </a>
      </div>
    );
  }

  return (
    <div className="mt-4 bg-gradient-to-br from-emerald-50 to-green-100 rounded-xl border-2 border-emerald-300 shadow-sm p-4">
      <div className="flex items-center gap-2 mb-2">
        <div className="p-1.5 bg-emerald-100 rounded-md">
          <Heart className="w-4 h-4 text-emerald-600" />
        </div>
        <h3 className="font-bold text-emerald-800 text-sm leading-tight">
          Prime App'Ines à l'embauche
        </h3>
      </div>

      <div className="flex items-baseline gap-2 mb-2">
        <span className="font-bold text-2xl text-emerald-900">300€</span>
        <span className="text-xs text-emerald-700">prime unique</span>
      </div>

      <p className="text-xs text-emerald-800 leading-snug mb-3">
        Versée après validation de ta période d'essai. Envoie ton CV pour connaître les conditions.
      </p>

      <a
        href={cvSubmissionLink}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackAppinesCtaClicked('hiring_bonus_sidebar', cvSubmissionLink)}
        aria-label="Découvrir App'Ines et envoyer ton CV pour bénéficier de la prime de 300€"
        className="inline-flex items-center justify-center gap-1.5 w-full px-3 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg font-semibold text-xs shadow-sm hover:shadow transition-all"
      >
        <Heart className="w-3.5 h-3.5" />
        <span>Envoyer mon CV</span>
        <ExternalLink className="w-3 h-3" />
      </a>
    </div>
  );
}
